import { Button } from '@tempo-io/sui-button';
import { Dependency, Tune } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';

type VisualizationNoItemsMatchLayoutStateProps = {
  onOpenFormatPanel?: () => void;
};

export const VisualizationNoItemsMatchLayoutState = ({
  onOpenFormatPanel,
}: VisualizationNoItemsMatchLayoutStateProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col w-full items-center gap-4 py-8">
      <div className="flex items-center justify-center p-2 rounded-xl bg-bg-neutral">
        <Dependency className="h-8 w-8" />
      </div>

      <div className="text-xl font-bold">
        {t(($) => $.views.visualization.emptyStates.noItemsMatchLayoutOptions.title)}
      </div>
      <div className="mb-2 text-text-neutral-secondary">
        {t(($) => $.views.visualization.emptyStates.noItemsMatchLayoutOptions.description)}
      </div>
      {onOpenFormatPanel && (
        <Button className="my-2" onClick={onOpenFormatPanel}>
          <Tune />
          {t(($) => $.views.visualization.emptyStates.noItemsMatchLayoutOptions.button)}
        </Button>
      )}
    </div>
  );
};
